const _lwDispatchQueue = [];
const _lwListenerQueue = [];

export function getLW() {

    if (window.Livewire) {
        return window.Livewire;
    }

    try {
        if (typeof Livewire !== 'undefined') return Livewire;
    } catch {
        console.error('No Livewire object found.');
    }

    return null;
};

export function lwDispatch(event, payload = {}) {
    const L = getLW()
    if (L && (L.dispatch || L.emit)) {
        if (L.dispatch) L.dispatch(event, payload)
        if (L.emit) L.emit(event, payload) // v2 fallback
    } else {
        _lwDispatchQueue.push({ event, payload })
    }
};

export function lwOn(event, cb) {
    const L = getLW()
    if (L?.on) L.on(event, cb)
    else if (window.livewire?.on) window.livewire.on(event, cb)

    // always also listen as a DOM CustomEvent
    window.addEventListener(event, e => { try { cb(e?.detail ?? {}) } catch (err) { console.error(err) } })
};

export function lwOnce(event, timeoutMs = 10000) {
    return new Promise((resolve) => {
        let settled = false;
        const handler = (payload = {}) => {
            if (settled) return;
            settled = true;
            resolve(payload || {});
        };
        lwOn(event, handler);
        setTimeout(() => !settled && resolve({}), timeoutMs);
    });
};

export function flushLW() {
    const L = getLW()
    if (!L) return
    for (const it of _lwListenerQueue.splice(0)) {
        if (L.on) L.on(it.event, it.cb)
    }
    for (const it of _lwDispatchQueue.splice(0)) {
        if (L.dispatch) L.dispatch(it.event, it.payload)
        if (L.emit) L.emit(it.event, it.payload)
    }
};

window.addEventListener('livewire:load', flushLW);
queueMicrotask(flushLW);
